
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/artworks",
      function () {
        return require("private-next-pages/artworks/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/artworks"])
      });
    }
  